import React, { useState, useEffect } from "react";
import axios from "axios";
import { url } from "../../Constant";
import { useAuth } from "../../Context/AuthProvider";
import ReactPaginate from "react-paginate";
import FilterModal from "../../components/Modal/FilterModal";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const NewIncomingCalls = () => {
  const accessVpbxId = sessionStorage.getItem("companyData");
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [size, setSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [incomingData, setIncomingData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [apicalled, setApiCalled] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [dateError, setDateError] = useState("");
  const [error, setError] = useState("");
  const [filterData, setFilterData] = useState({
    start_date: null,
    end_date: null,
    duration_type: "",
    duration: null,
    condition: null,
    agent_number: "",
    customer_number: "",
    call_type: "",
  });

  // functions
  const handleOpenFilterModal = () => {
    setOpenFilterModal(true);
  };
  const handleCloseFilterModal = () => {
    setOpenFilterModal(false);
  };

  const getIncomingCalls = (page) => {
    let api;

    if (auth.role === "1") {
      if (accessVpbxId === process.env.REACT_APP_POSTEX_VPBX) {
        api = "super-postex-incoming-cdrs";
      } else if (accessVpbxId === process.env.REACT_APP_LEOPARD_VPBX) {
        api = "super-leopard-incoming-cdrs";
      } else if (accessVpbxId === process.env.REACT_APP_TCS_VPBX) {
        api = "super-tcs-incoming-cdrs";
      } else if (accessVpbxId === "65f841ec57f0d") {
        api = "super-travel-channel-inboundCdrs";
      } else {
        api = "super-inbound-calls";
      }
    } else if (auth.role === "3") {
      if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
        api = "user-postex-incoming-cdrs";
      } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
        api = "user-leopard-incoming-cdrs";
      } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
        api = "user-tcs-incoming-cdrs";
      } else if (auth.vpbx_id === "65f841ec57f0d") {
        api = "user-travel-channel-inboundCdrs";
      } else {
        api = "user-inbound-calls";
      }
    } else {
      if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
        api = "postex-incoming-cdrs";
      } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
        api = "leopard-incoming-cdrs";
      } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
        api = "tcs-incoming-cdrs";
      } else if (auth.vpbx_id === "65f841ec57f0d") {
        api = "travel-channel-inboundCdrs";
      } else {
        api = "inbound-calls";
      }
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.role === "1" ? accessVpbxId : auth.vpbx_id,
          page: page,
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          agent_number: filterData.agent_number,
          customer_number: parseInt(filterData.customer_number),
          duration_type: filterData.duration_type,
          duration: filterData.duration,
          condition: filterData.condition,
          call_response: filterData.call_type,
          limit: size,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(
        (response) => {
          console.log(response.data.code);
          if (response.data.code === 200) {
            setLoader(false);
            setApiCalled(false);
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setIncomingData([]);
            } else if (response.data.message === "Data Found") {
              setIncomingData(response.data.data.inboundCalls);
              setPageCount(response.data.data.pages);
            }
          } else {
            setIncomingData([]);
            setPageCount(0);
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  const getFilterData = () => {
    var Errorvariable = "";
    if (
      filterData.start_date === null &&
      filterData.end_date === null &&
      filterData.agent_number === "" &&
      filterData.customer_number === "" &&
      filterData.duration_type === ""
    ) {
      Errorvariable = "Please select parameters for filter";
      setError(Errorvariable);
    }
    if (Errorvariable === "" && dateError === "") {
      setLoader(true);

      let api;
      if (auth.role === "1") {
        if (accessVpbxId === process.env.REACT_APP_TCS_VPBX) {
          api = "super-tcs-incoming-cdrs";
        } else if (accessVpbxId === process.env.REACT_APP_LEOPARD_VPBX) {
          api = "super-leopard-incoming-cdrs";
        } else if (accessVpbxId === process.env.REACT_APP_POSTEX_VPBX) {
          api = "super-postex-incoming-cdrs";
        } else if (accessVpbxId === "65f841ec57f0d") {
          api = "super-travel-channel-inboundCdrs";
        } else {
          api = "super-inbound-calls";
        }
      } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
        api = "tcs-incoming-cdrs";
      } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
        if (auth.role === "2") {
          api = "leopard-incoming-cdrs";
        } else {
          api = "user-leopard-incoming-cdrs";
        }
      } else if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
        if (auth.role === "2") {
          api = "postex-incoming-cdrs";
        } else {
          api = "user-postex-incoming-cdrs";
        }
      } else if (auth.vpbx_id === "65f841ec57f0d") {
        if (auth.role === "2") {
          api = "travel-channel-inboundCdrs";
        } else {
          api = "user-travel-channel-inboundCdrs";
        }
      } else {
        api = auth.role === "3" ? "user-inbound-calls" : "inbound-calls";
      }
      axios
        .post(
          url + api,
          {
            vpbx_id: auth.role === "1" ? accessVpbxId : auth.vpbx_id,
            start_date: filterData.start_date,
            end_date: filterData.end_date,
            agent_number: filterData.agent_number,
            customer_number: parseInt(filterData.customer_number),
            duration_type: filterData.duration_type,
            duration: filterData.duration,
            condition: filterData.condition,
            call_response: filterData.call_type,
            limit: size,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          },
        )
        .then(
          (response) => {
            setLoader(false);
            if (response.data.code === 200) {
              if (
                response.data.message === "Data Not Found" &&
                response.data.data.length === 0
              ) {
                setIncomingData([]);
              } else if (response.data.message === "Data Found") {
                setIncomingData(response.data.data.inboundCalls);
                setPageCount(response.data.data.pages);
              }
            } else {
              setIncomingData([]);
              setPageCount(0);
            }
            handleCloseFilterModal();
          },
          (error) => {
            console.log(error);
          },
        );
    } else {
      setLoader(false);
    }
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const filteredIncomming = incomingData.filter((val) => {
    return (
      (val.src && val.src.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.dst && val.dst.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.duration &&
        typeof val.duration === "string" &&
        val.duration.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.agent_id &&
        val.agent_id.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.ext_name &&
        val.ext_name.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.call_response &&
        val.call_response.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.calldate &&
        val.calldate.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  useEffect(() => {
    setLoader(true);
    getIncomingCalls(currentPage);
  }, [size]);

  useEffect(() => {
    if (apicalled === true) {
      getIncomingCalls(1);
    }
  }, [apicalled]);

  const handleExportData = () => {
    setDownloadLoader(true);
    let api;
    if (auth.role === "1") {
      if (accessVpbxId === process.env.REACT_APP_TCS_VPBX) {
        api = "super-tcs-download-cdrs";
      } else if (accessVpbxId === process.env.REACT_APP_LEOPARD_VPBX) {
        api = "super-leopard-download-cdrs";
      } else if (accessVpbxId === process.env.REACT_APP_POSTEX_VPBX) {
        api = "super-postex-download-cdrs";
      } else if (accessVpbxId === "65f841ec57f0d") {
        api = "super-travel-channel-downloadCdrs";
      } else {
        api = "super-downloadCdrs";
      }
    } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
      if (auth.role === "2") {
        api = "tcs-download-cdrs";
      } else {
        api = "user-tcs-download-cdrs";
      }
    } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
      if (auth.role === "2") {
        api = "leopard-download-cdrs";
      } else {
        api = "user-leopard-download-cdrs";
      }
    } else if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
      if (auth.role === "2") {
        api = "postex-download-cdrs";
      } else {
        api = "user-postex-download-cdrs";
      }
    } else if (auth.vpbx_id === "65f841ec57f0d") {
      if (auth.role === "2") {
        api = "travel-channel-downloadCdrs";
      } else {
        api = "user-travel-channel-downloadCdrs";
      }
    } else {
      if (auth.role === "2") {
        api = "downloadCdrs";
      } else {
        api = "user-downloadCdrs";
      }
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.role === "1" ? accessVpbxId : auth.vpbx_id,
          call_type: "inbound",
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          agent_number: filterData.agent_number,
          customer_number: filterData.customer_number,
          duration_type: filterData.duration_type,
          duration: filterData.duration,
          condition: filterData.condition,
          call_response: filterData.call_type,
          limit: size,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setDownloadLoader(false);
            window.location.href = response.data.data;
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  const handlePageChange = (data) => {
    setLoader(true);
    getIncomingCalls(data.selected + 1);
    setCurrentPage(data.selected + 1);
  };

  return (
    // <div className="dashboardWrp">
    //   <div className="uk-container uk-container-large">
    //     <div className="dashboardTop">
    //       <div uk-grid="" className="uk-grid uk-grid-small">
    //         <div className="uk-width-2-3">
    //           <div className="dashboardIntro">
    //             <h3>CALL RECORDS</h3>
    //             {auth.role === "2" && (
    //               <p>
    //                 Use this page to view the call logs or call history,
    //                 including inbound, outbound, and missed calls.
    //               </p>
    //             )}
    //           </div>
    //         </div>

    //         <div className="uk-width-1-1 ">
    //           <ul
    //             className="uk-subnav callSwitcher"
    //             uk-switcher="connect: .callClass"
    //           >
    //             {(auth.role === "2" || auth.role === "3") && (
    //               <>
    //                 {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //                   <li onClick={() => navigate("/incoming-calls")}>
    //                     <a href="#">Incoming calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //                   <li onClick={() => navigate("/outgoing-calls")}>
    //                     <a href="#">Outgoing calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //                   <li onClick={() => navigate("/missed-calls")}>
    //                     <a href="#">Offtime calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" ||
    //                 checkPermissions("ext-to-ext-calls") ? (
    //                   <li onClick={() => navigate("/ext-to-ext")}>
    //                     <a href="#">Ext. to Ext.</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.call_initiated === "1" ? (
    //                   <li onClick={() => navigate("/feedback")}>
    //                     <a href="#">Feedback</a>
    //                   </li>
    //                 ) : null}
    //               </>
    //             )}
    //           </ul>
    //         </div>
    //       </div>
    //       <ul className="uk-switcher uk-margin callClass">
    //         {(auth.role === "2" || auth.role === "3") && (
    //           <>
    //             {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //               <li>
    <div className="ImcomingCallMain ImcomingCallMainRecord">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-2">
          <div className="uk-text-left">
            <div className="CustomSearch">
              <form className="uk-search uk-search-default">
                <input
                  className="uk-search-input"
                  type="text"
                  placeholder="Search by all field"
                  value={searchText}
                  onChange={handleSearch}
                />
              </form>
            </div>
          </div>
        </div>

        <div className="uk-width-1-2">
          <div className="uk-text-right">
            <span>
              <div className="uk-inline uk-text-left">
                <div
                  id="datepickerdrop"
                  uk-drop="mode: click; animation: uk-animation-slide-top-small; animate-out: true"
                  className="date-picker-container"
                >
                  <div className="date-picker-btn-container uk-text-right">
                    <button className="date-selection-btn">Search</button>
                  </div>
                </div>
                {(auth.role === "1" ||
                  auth.role === "2" ||
                  checkIndividualPermission(
                    "incoming-calls",
                    "read_and_write",
                  )) && (
                  <>
                    <button
                      className="exportData-button"
                      onClick={handleOpenFilterModal}
                      disabled={loader ? true : false}
                    >
                      Add Filter
                    </button>
                    <button
                      className="exportData-button"
                      onClick={handleExportData}
                    >
                      {downloadLoader ? (
                        <div uk-spinner=""></div>
                      ) : (
                        "Export Data"
                      )}
                    </button>
                  </>
                )}
              </div>
            </span>
          </div>
        </div>
      </div>
      <div>
        {loader ? (
          <div uk-spinner="" className="tableloader"></div>
        ) : filteredIncomming.length === 0 ? (
          <div className="customtableNoDataText">
            There are no records to display
          </div>
        ) : (
          <div className="customTable">
            <table>
              <thead>
                <tr>
                  <th>Customer Number</th>
                  <th>Master No.</th>
                  <th>Agent Duration</th>
                  <th>Total Duration</th>
                  <th>Destination</th>
                  {(auth.vpbx_id === "6661b5255b5ee" ||
                    auth.is_feedback === "1") && <th>Feedback</th>}
                  <th>Transfer Destination</th>
                  <th>IVR</th>
                  <th>Call Response</th>
                  <th>Time</th>
                  <th>Recording</th>
                </tr>
              </thead>
              <tbody>
                {filteredIncomming.map((val, index) => (
                  <>
                    <tr key={index}>
                      <td>{val.src}</td>
                      <td>{val.dst}</td>
                      <td>{val.duration}</td>
                      <td>{val.total_call_duration}</td>
                      <td>{val.agent_id}</td>
                      {(auth.vpbx_id === "6661b5255b5ee" ||
                        auth.is_feedback === "1") && <th>{val.feedback}</th>}
                      <td>{val.transfer_agent_id}</td>
                      <td>{val.ivr_params}</td>
                      <td>{val.call_response}</td>
                      <td>{val.calldate}</td>
                      <td>
                        <audio
                          className="mp3Audio"
                          controls
                          target="_blank"
                          rel="noopener noreferrer"
                          onContextMenu={(e) => e.preventDefault()}
                        >
                          <source
                            // src={
                            //   process.env.REACT_APP_CALL_RECORDS_AUDIO_URL +
                            //   `${auth.vpbx_id}/` +
                            //   moment(val.start_call_date).format("YYYYMMDD") +
                            //   "/inbound/" +
                            //   `${val.userfield}.wav`
                            // }
                            src={
                              process.env.REACT_APP_CALL_RECORDS_AUDIO_URL +
                              `${auth.role === "1" ? accessVpbxId : auth.vpbx_id}/` +
                              moment(val.start_call_date).format("YYYYMMDD") +
                              "/inbound/" +
                              `${val.userfield}.wav`
                            }
                          />
                          Your browser does not support the audio tag.
                        </audio>
                      </td>
                    </tr>
                    <br />
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="tablePaginationBox ">
          <div className="uk-margin-left">
            Show{" "}
            <select onChange={(e) => setSize(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>{" "}
            entries
          </div>
          <div>
            {pageCount > 1 && (
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"...."}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                containerClassName={
                  "uk-pagination uk-float-right contatPagination"
                }
                activeClassName={"uk-active"}
                marginPagesDisplayed={3}
                pageRangeDisplayed={6}
              />
            )}
          </div>
        </div>
      </div>
      {openFilterModal && (
        <FilterModal
          closeModal={handleCloseFilterModal}
          setFilterData={setFilterData}
          filterData={filterData}
          setApiCalled={setApiCalled}
          getFilterData={getFilterData}
          setDateError={setDateError}
          dateError={dateError}
          error={error}
          setError={setError}
          Cdr="Incoming"
          loader={loader}
        />
      )}
    </div>
    //                 {" "}
    //               </li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("ext-to-ext-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.call_initiated === "1" ? <li></li> : null}
    //           </>
    //         )}
    //       </ul>
    //     </div>
    //   </div>
    // </div>
  );
};

export default NewIncomingCalls;
